import React from 'react';
import { Status } from '../../interfaces/Status';

export enum StateClass {
  undone = 'undone',
  active = 'active',
  done = 'done',
}

export type State = keyof typeof StateClass

type Props = {
  status: Status
  state?: State
}

export default function StatusItem ({ status, state = 'undone' }: Props): React.ReactElement {
  return (
    <div className={ `timeline-item ${ StateClass[state] }` }>
      <div className="timeline-marker is-icon">
        <div className="card-header-icon">
          { status.icon && 
          <span className="icon has-text-tertiary is-small">
            <i className={ `${ status.icon }` }
              aria-hidden="true"></i>
          </span>
          }
        </div>
      </div>
      <div className="timeline-content">
        <p className="tag is-small is-size-6">
          { status.date.toLocaleDateString('fr-FR', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          }) }
        </p>
        <p className={ `text is-level-1 ${ StateClass[state] === 'active' ? 'has-text-weight-semibold' : '' }` }>{ status.label }</p>
      </div>
    </div>
  );
}